export enum StepsEnum {
  condition = 0,
  action = 1,
}
